import React, { Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import { RouteAuthGuard } from "./components/guard/RouteAuthGuard";
import { Reigenspf0001 } from "./pages/reigenspf/Reigenspf001";
import { Reievespf002 } from "./pages/reievespf/Reievespf002";
import { Reilogspf001 } from "./pages/reilogspf/Reilogspf001";
import { Reievespf001 } from "./pages/reievespf/Reievespf001";
import { Reilogspf002 } from "./pages/reilogspf/Reilogspf002";
import { Reievespf003 } from "./pages/reievespf/Reievespf003";
import { Reievespf005 } from "./pages/reievespf/Reievespf005";

const App: React.FC = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route
                    index
                    element={
                        <RouteAuthGuard
                            component={<Reilogspf001 />}
                            redirect="/login"
                            path="/login"
                        />
                    }
                    path="/"
                />
                <Route
                    index
                    element={
                        <RouteAuthGuard
                            component={<Reilogspf001 />}
                            redirect="/login"
                            path="/login"
                        />
                    }
                    path="/login"
                />

                <Route
                    index
                    element={
                        <RouteAuthGuard
                            component={<Reilogspf002 />}
                            redirect="/login"
                            path="/reset/password"
                        />
                    }
                    path="/reset/password"
                />

                <Route
                    index
                    element={
                        <RouteAuthGuard
                            component={<Reigenspf0001 />}
                            redirect="/login"
                            path="/mypage"
                        />
                    }
                    path="/mypage"
                />

                <Route
                    index
                    element={
                        <RouteAuthGuard
                            component={<Reievespf001 />}
                            redirect="/login"
                            path="/edit"
                        />
                    }
                    path="/edit"
                />

                <Route
                    index
                    element={
                        <RouteAuthGuard
                            component={<Reievespf003 />}
                            redirect="/login"
                            path="/detail"
                        />
                    }
                    path="/detail"
                />

                <Route
                    index
                    element={
                        <RouteAuthGuard
                            component={<Reievespf002 />}
                            redirect="/login"
                            path="/makeup"
                        />
                    }
                    path="/makeup"
                />

                <Route
                    index
                    element={
                        <RouteAuthGuard
                            component={<Reievespf005 />}
                            redirect="/login"
                            path="/cancelwait"
                        />
                    }
                    path="/cancelwait"
                />
            </Routes>
        </BrowserRouter>
    );
};

export default App;
